import { useQuery } from "@tanstack/react-query";
import { membershipApi } from "@bw/shared/api";
import type { VisitBalanceResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The caller's visit balances across all visits_card subscriptions (GET
 * /memberships/visit-balances → VisitBalanceResponse[]), SERVER-SCOPED to the
 * auth user. Read-only — balances are minted/decremented server-side. Keyed to
 * ONE cache slot; the My Memberships list joins these onto the subscriptions by
 * subscription_id.
 */
export function useVisitBalances() {
  return useQuery<VisitBalanceResponse[]>({
    queryKey: queryKeys.memberships.visitBalances(),
    queryFn: () => membershipApi.listVisitBalances(),
  });
}
